import { useApolloClient } from "@apollo/client";

import { GET_ACCOUNT_FILES_QUERY } from "graphqlQueries/accountFiles";
import { READ_VERSION_FILES_QUERY } from "graphqlQueries/versions";
import { getAccountFilesMapper } from "graphqlQueries/accountFiles.map";
import { readVersionFilesMapper } from "graphqlQueries/versions.map";
import { IQ_PATCH_TAGS } from "constants/FileNames";
import { VERSION, ACCOUNT } from "constants/patchTagSections";
import get from "lodash-es/get";

export default function usePatchTagsData(variables, section) {
  const client = useApolloClient();
  return () => {
    switch (section) {
      case VERSION:
        return get(
          readVersionFilesMapper(
            client.readQuery({
              query: READ_VERSION_FILES_QUERY,
              variables,
            }),
          ).filter((item) => item.name === IQ_PATCH_TAGS),
          "0.info",
          {},
        );
      case ACCOUNT:
        return get(
          getAccountFilesMapper(
            client.readQuery({
              query: GET_ACCOUNT_FILES_QUERY,
              variables,
            }),
          ).filter((item) => item.name === IQ_PATCH_TAGS),
          "0.info",
          {},
        );
    }
  };
}
